<template>
  <nav
    v-if="permissions"
    class="sidebar position-fixed h-100 overflow-auto"
  >
    <div class="sidebar-header text-center my-5">
      <router-link
        :to="{ name: 'home' }"
        class="mx-auto"
      >
        <img
          :title="$t('img.logo')"
          :alt="$t('img.logo')"
          src="@/assets/img/logo.png"
          class="brand mt-3"
        >
      </router-link>
    </div>

    <div class="sidebar-sticky">
      <ul class="nav list-unstyled font-custom">
        <template v-if="hasPermission('distributors:read') || hasPermission('distributors:write')">
          <li class="d-block w-100 p-3 text-uppercase">
            <a
              href="#distributors"
              data-bs-toggle="collapse"
              class="dropdown-toggle"
              aria-expanded="false"
            >
              {{ $t('title.distributors') }}
            </a>
          </li>

          <ul
            id="distributors"
            class="collapse list-unstyled w-100 p-3"
          >
            <template v-if="hasPermission('distributors:read')">
              <li
                class="d-block w-100 p-2"
                style="display:none !important"
              >
                <a href="/distributor/listDistributor">
                  {{ $t("title.distributorsList") }} <sup style="color:Red"><b>(Old)</b></sup>
                </a>
              </li>
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'distributor-list' }">
                  {{ $t('title.distributorsList') }}
                </router-link>
              </li>
            </template>
            <template v-if="hasPermission('distributors:write')">
            <!-- li class="d-block w-100 p-2">
              <a href="/distributor/createDistributor">
                {{ $t('title.distributorsCreate') }}
              </a>
            </li -->
            </template>
          </ul>
        </template>

        <template
          v-if="hasPermission('commercialProduct') || hasPermission('commercialProduct:read') || hasPermission('commercialProduct:create')
            || hasPermission('product') || hasPermission('product:read') || hasPermission('product:create')"
        >
          <li class="d-block w-100 p-3 text-uppercase">
            <a
              href="#products"
              data-bs-toggle="collapse"
              class="dropdown-toggle"
            >
              {{ $t('title.products') }}
            </a>
          </li>

          <ul
            id="products"
            class="collapse list-unstyled w-100 p-3"
          >
            <!--template v-if="hasPermission('technicalProduct') || hasPermission('technicalProduct:read') || hasPermission('commercialProduct') || hasPermission('commercialProduct:read')">
              <li class="d-block w-100 p-2">
                <a href="/product/listProduct">
                  {{ $t('title.productsList') }}
                </a>
              </li>
            </template-->


            <!-- TODO : Remove all commercial or technical product permissions to replace it by product ones -->
            <template
              v-if="hasPermission('commercialProduct') || hasPermission('commercialProduct:read')
                || hasPermission('product') || hasPermission('product:read') "
            >
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'product-list' }">
                  {{ $t("title.product.list") }}
                </router-link>
              </li>
            </template>

            <template
              v-if="hasPermission('product') || hasPermission('product:create')"
            >
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'product-create' }">
                  {{ $t("title.product.create") }}
                </router-link>
              </li>
            </template>

            <template
              v-if="hasPermission('product') || hasPermission('product:create')"
            >
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'request-list' }">
                  {{ $t("title.request.list") }}
                </router-link>
              </li>
            </template>

            <template v-if="hasPermission('internal')">
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'product-import' }">
                  {{ $t("title.product.import") }}
                </router-link>
              </li>
            </template>

            <template v-if="hasPermission('param:control')">
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'product-export' }">
                  {{ $t("title.product.export") }}
                </router-link>
              </li>
            </template>
          </ul>
        </template>

        <template v-if="hasPermission('affiliates:read') || hasPermission('affiliates:write')">
          <li
            class="d-block w-100 p-3 text-uppercase"
            style="display:none !important"
          >
            <a href="/affiliate/searchAffiliate">
              {{ $t('title.affiliates') }}  <sup style="color:Red"><b>(Old)</b></sup>
            </a>
          </li>
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'affiliate-list' }">
              {{ $t('title.affiliates') }}
            </router-link>
          </li>
        </template>

        <template v-if="hasPermission('beneficiaries:read')">
          <li
            class="d-block w-100 p-3 text-uppercase"
            style="display:none !important"
          >
            <a href="/beneficiaries/beneficiaryservice">
              {{ $t('title.beneficiaries') }} <sup style="color:Red"><b>(Old)</b></sup>
            </a>
          </li>
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'beneficiaryservice-list' }">
              {{ $t('title.beneficiaries') }}
            </router-link>
          </li>
        </template>
        <template v-if="hasPermission('cards:read')">
          <li
            class="d-block w-100 p-3 text-uppercase"
            style="display:none !important"
          >
            <a href="/cards/cards">Cards <sup style="color:Red"><b>(Old)</b></sup></a>
          </li>
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'card-list' }">
              {{ $t('title.card.list') }}
            </router-link>
          </li>
        </template>
        <template v-if="hasPermission('accounts:read')">
          <li
            class="d-block w-100 p-3 text-uppercase"
            style="display:none !important"
          >
            <a href="/accounts/accounts">
              {{ $t('title.accounts') }} <sup style="color:Red"><b>(Old)</b></sup>
            </a>
          </li>
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'account-list' }">
              {{ $t('title.account.list') }}
            </router-link>
          </li>
        </template>
        <template v-if="hasPermission('orders:read')">
          <li
            class="d-block w-100 p-3 text-uppercase"
            style="display:none !important"
          >
            <a href="/orders/orders">
              {{ $t('title.orders') }} <sup style="color:Red"><b>(Old)</b></sup>
            </a>
          </li>
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'order-list' }">
              {{ $t('title.orders') }}
            </router-link>
          </li>
        </template>

        <template v-if="hasPermission('authorizations:read')">
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'authorization-list' }">
              {{ $t("title.authorization.list") }}
            </router-link>
          </li>
        </template>

        <template v-if="hasPermission('clearings:read')">
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'clearing-list' }">
              {{ $t('title.clearing.list') }}
            </router-link>
          </li>
        </template>

        <template v-if="hasPermission('param:control')">
          <li class="d-block w-100 p-3 text-uppercase">
            <router-link :to="{ name: 'param-control' }">
              {{ $t("title.param.control") }}
            </router-link>
          </li>
        </template>

        <template v-if="hasPermission('users:read') || hasPermission('users:write') || hasPermission('users:role')">
          <li class="d-block w-100 p-3 text-uppercase">
            <a
              href="#admin"
              data-bs-toggle="collapse"
              class="dropdown-toggle"
            >
              {{ $t('title.admin') }}
            </a>
          </li>

          <ul
            id="admin"
            class="collapse list-unstyled w-100 p-3"
          >
            <template v-if="hasPermission('users:read')">
              <li
                class="d-block w-100 p-2"
                style="display:none !important"
              >
                <a href="/administration/user/listUser">
                  {{ $t('title.usersList') }} <sup style="color:Red"><b>(Old)</b></sup>
                </a>
              </li>
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'user-list' }">
                  {{ $t('title.user.list') }}
                </router-link>
              </li>
            </template>
            <template v-if="hasPermission('users:write')">
              <li
                class="d-block w-100 p-2"
                style="display:none !important"
              >
                <a href="/administration/user/createUser">
                  {{ $t('title.usersCreate') }} <sup style="color:Red"><b>(Old)</b></sup>
                </a>
              </li>
              <li class="d-block w-100 p-2">
                <router-link :to="{ name: 'user-create' }">
                  {{ $t('title.user.creation') }}
                </router-link>
              </li>
            </template>

            <template v-if="hasPermission('users:role')">
              <li
                class="d-block w-100 p-2"
                style="display:none !important"
              >
                <a href="/administration/profile/createProfile">
                  {{ $t('title.profilesPage') }} <sup style="color:Red"><b>(Old)</b></sup>
                </a>
              </li>

              <li class="d-block w-100 p-2 ">
                <router-link :to="{ name: 'profile-list' }">
                  {{ $t('title.profile.list') }}
                </router-link>
              </li>

              <li class="d-block w-100 p-2 ">
                <router-link :to="{ name: 'profile-create' }">
                  {{ $t('title.profile.creation') }}
                </router-link>
              </li>
            </template>
          </ul>
        </template>

        <template v-if="hasPermission('internal')">
          <li class="d-block w-100 p-3 text-uppercase">
            <a href="/planning/listebatchs">
              {{ $t('title.batchPage') }}
            </a>
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')) ? JSON.parse(sessionStorage.getItem('user')).permissions : null
    }
  },

  methods: {
    hasPermission (permission) {
      if (this.permissions) {
        if (!String.prototype.includes) {
          return this.permissions.indexOf(permission, 0) !== -1
        } else {
          return this.permissions.includes(permission)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.sidebar {
  background-color: $accent-primary;
  min-width: 250px;
  padding-right: 0 !important;

  .sidebar-header .brand {
    max-width: 150px;
  }

  .nav {
    li {
      &:hover {
        background-color: $shade-dark;
      }

      a {
        text-decoration: none;
        color: $shade-lightest;
        font-size: 0.95rem;
        letter-spacing: 0.08rem;

        &.router-link-active {
          color: #bbb;
          transition: all 0.2s;
        }

        &:hover {
          text-decoration: none;
          color: $accent-primary;
        }
      }
    }
    ul.collapse {
      background-color: $shade-dark;
    }
  }
}
</style>
